module.exports = __webpack_public_path__ + "img/streakicon.79555007.svg";